import { IBaseAnalyticsCombined } from "@/store/analyticsDataStore";
import { SetStateAction, useEffect, useState } from "react";
import { returnKeysToMapGeneric } from "./analyticsHelperFunctions";
import SelectAllCheckBox from "./SelectAllCheckBox";
import { ITransactionCostFilters } from "./TransactionCost/TransactionCostIndex";

const CurrencyAndInstrumentFilters = ({
  data,
  dataFilters,
  setDataFilters,
}: {
  data: any;
  dataFilters: ITransactionCostFilters | any;
  setDataFilters: React.Dispatch<SetStateAction<ITransactionCostFilters>>;
}) => {
  const keys = [
    "instrumentType",
    "currency",
    "structureType",
  ] as (keyof IBaseAnalyticsCombined)[];

  const [keysToMap, setKeysToMap] = useState(
    returnKeysToMapGeneric(data, keys),
  );

  useEffect(() => {
    setKeysToMap(returnKeysToMapGeneric(data, keys));
  }, [data]);

  useEffect(() => {
    if (dataFilters && keysToMap) {
      setDataFilters({
        ...dataFilters,
        selectedCurrencies: keysToMap.currencyKeys,
        selectedInstruments: keysToMap.instrumentTypeKeys,
        selectedSecurities: keysToMap.securityTypeKeys,
      });
    }
  }, []);

  const handleCheckboxChange = (filterValue: string) => {
    const currentState = dataFilters.selectedCurrencies;

    let newData = [];
    if (currentState.includes(filterValue)) {
      // Remove if already selected
      newData = currentState.filter((c: string) => c !== filterValue);
    } else {
      // Add if not selected
      newData = [...currentState, filterValue];
    }
    setDataFilters({ ...dataFilters, selectedCurrencies: newData });
  };

  const handleCheckboxChangeInstrument = (instrument: string) => {
    const currentState = dataFilters.selectedInstruments;

    let newData = [];
    if (currentState.includes(instrument)) {
      // Remove if already selected
      newData = currentState.filter((c: string) => c !== instrument);
    } else {
      // Add if not selected
      newData = [...currentState, instrument];
    }
    setDataFilters({ ...dataFilters, selectedInstruments: newData });
  };

  return (
    <>
      {keysToMap ? (
        <div className="flex h-full w-full justify-between overflow-hidden">
          <div className="flex h-full w-full flex-col pl-2">
            <div>Currency:</div>

            <div className="flex h-fit flex-col overflow-auto pl-2 pt-2">
              <SelectAllCheckBox
                dataFilters={dataFilters}
                setDataFilters={setDataFilters}
                dataFilterField={"selectedCurrencies"}
                keysToMap={keysToMap}
                keysToMapField={"currencyKeys"}
              />
              {keysToMap.currencyKeys.map((currency, index) => (
                <div className=" text-xs" key={index}>
                  <input
                    type="checkbox"
                    className=" accent-blue-500"
                    checked={
                      dataFilters && dataFilters.selectedCurrencies
                        ? dataFilters.selectedCurrencies.includes(currency)
                        : null
                    }
                    onChange={() => handleCheckboxChange(currency)}
                  />
                  <span className="pl-1">{currency}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="flex h-full w-full flex-col pl-2">
            <div>Instrument:</div>

            <div className="flex h-full flex-col overflow-auto pl-2 pt-2">
              <SelectAllCheckBox
                dataFilters={dataFilters}
                setDataFilters={setDataFilters}
                dataFilterField={"selectedInstruments"}
                keysToMap={keysToMap}
                keysToMapField={"instrumentTypeKeys"}
              />
              {keysToMap.instrumentTypeKeys.map((instrument, index) => (
                <div className=" text-xs" key={index}>
                  <input
                    type="checkbox"
                    className=" accent-blue-500"
                    checked={
                      dataFilters && dataFilters.selectedInstruments
                        ? dataFilters.selectedInstruments.includes(instrument)
                        : null
                    }
                    onChange={() => handleCheckboxChangeInstrument(instrument)}
                  />
                  <span className="pl-1">{instrument}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default CurrencyAndInstrumentFilters;
